import React from "react";
import Helper from "../../common/helper";
import { parsePhoneNumber } from "awesome-phonenumber";
import { SubHeader, TextBold, getPreferredLanguage } from "./review-step";

export default function ReviewCard({
  localStorageDatas,
  couponObj,
  locationData,
  isUserLogged,
  businessCategories,
  languages,
  couponExists,
  totalAmount,
  isExpress,
  removeProduct,
  isRenewalPage,
  className,
}) {
  return (
    <div id="review-card" className="w-[309px]">
      {localStorageDatas?.members.map((item, index) => {
        let selected_item = item.selected_product[0];
        const getCoupon = Helper.checkCoupon(selected_item, couponObj);
        const PWP = Helper.newpwpCheck(
          selected_item,
          isUserLogged,
          locationData,
          businessCategories
        );
        const {
          isShown,
          title,
          type_of_member,
          selected_product,
          leah_card_number,
          first_name,
          last_name,
          phone_number,
          address_line_1,
          address_line_2,
          address_line_3,
          city,
          state,
          postal_code,
          country,
          email,
          preferred_language,
        } = item;

        // console.log("item12312312", item);

        const formatPhoneNumber = parsePhoneNumber(
          `+${phone_number?.inputVal}`
        );

        if (getCoupon.exists == true) {
          couponExists = true;
          totalAmount = getCoupon.total + " (coupon applied)";
        } else if (selected_product && selected_item && selected_item.tax_amt) {
          totalAmount =
            parseFloat(selected_item.purchase_price) +
            parseFloat(selected_item.tax_amt);
        }
        return (
          <div
            className="holder-review-details flex flex-col border border-gray-400 rounded p-4"
            key={index}
          >
            {/* <div className='holder-review-button ml-auto mb-1'>
                                {
                                    type_of_member === 'primary_owner' ? null : (
                                        !isExpress ? (
                                            <button
                                                type='button'
                                                onClick={() => removeProduct(item)}
                                            >x {languages.removeText ? languages.removeText : 'Remove'}
                                            </button>
                                        ) : ''
                                    )
                                }
                            </div> */}

            <div className="holder-title flex flex-col justify-center gap-4">
              <div id="contact-information">
                <SubHeader
                  headerMsg={languages.contactInfoSummary ? languages.contactInfoSummary : "Contact information summary"}
                  className="mb-5 leading-6"
                />
                {isExpress && type_of_member === "primary_owner" ? (
                  <ul className="details-list">
                    <li className="list pt-1 font-montserrat">
                      <strong>
                        {languages.membershipNumber
                          ? languages.membershipNumber
                          : "Membership number"}
                      </strong>{" "}
                      {leah_card_number}
                    </li>
                  </ul>
                ) : isExpress && isShown ? (
                  <ul className="details-list">
                    <li className="list pt-1 font-montserrat">
                      <strong>
                        {languages.membershipNumber
                          ? languages.membershipNumber
                          : "Membership number"}
                      </strong>{" "}
                      {leah_card_number}
                    </li>
                  </ul>
                ) : isRenewalPage && isShown ? (
                  <ul className="details-list">
                    <li className="list pt-1 font-montserrat capitalize">
                      {`${title} ${first_name} ${last_name}`}
                    </li>
                    <li
                      className="list pt-1 font-montserrat truncate"
                      title={email}
                    >
                      {email}
                    </li>
                    <li className="list pt-1 font-montserrat">
                      {phone_number.leahNum === undefined
                        ? phone_number
                        : phone_number.leahNum}
                    </li>
                    <li className="list pt-1 font-montserrat">
                      {address_line_1} {address_line_2}, {address_line_3}
                    </li>
                    <li className="list pt-1 font-montserrat">
                      {city} {state},{" "}
                      <span className="uppercase">{postal_code}</span>
                    </li>
                    <li className="list pt-1 font-montserrat">
                      {" "}
                      <span>{country}</span>
                    </li>
                  </ul>
                ) : (
                  !isExpress &&
                  !isRenewalPage &&
                  isShown && (
                    <ul className="details-list">
                      <li className="list pt-1 font-montserrat capitalize">{`${title} ${first_name} ${last_name}`}</li>
                      <li
                        className="list pt-1 font-montserrat truncate text-sm leading-5 font-normal"
                        title={email}
                      >
                        <TextBold textContent={`${languages.email ? languages.email : "Email"}:`} /> {email}
                      </li>
                      <li className="list pt-1 font-montserrat text-sm leading-5 font-normal">
                        <TextBold textContent={`${languages.phoneNumber ? languages.phoneNumber : "Phone number"}:`} />{" "}
                        {formatPhoneNumber?.number?.international}
                      </li>
                      <li className="list pt-1 font-montserrat text-sm leading-5 font-normal">
                        <TextBold textContent={`${languages.postCode ? languages.postCode : "Postal Code"}:`} /> {postal_code}
                      </li>
                      <li className="list pt-1 font-montserrat text-sm leading-5 font-normal">
                        <TextBold textContent={`${languages.country ? languages.country : "Country"}:`} /> {country}
                      </li>
                      <li className="list pt-1 font-montserrat text-sm leading-5 font-normal">
                        <TextBold textContent={`${languages.preferredLanguage ? languages.preferredLanguage : "Preferred language"}:`} />{" "}
                        {getPreferredLanguage(preferred_language) || "English"}
                      </li>
                    </ul>
                  )
                )}
              </div>

              <hr className="border-[#D9D9D9]" />

              <div id="membership-information" className="mt-1">
                <SubHeader
                  headerMsg={languages.cardSubscriptionPeriod ? languages.cardSubscriptionPeriod : "Your card and subscription period"}
                  className="mb-5"
                />

                <TextBold
                  textContent={item.selected_product[0].item_group_description}
                />
                <div className="text-sm font-montserrat font-normal pt-1">
                  {languages.oneYearSubscription
                    ? languages.oneYearSubscription
                    : "1 year subscription"}
                </div>
                {PWP.isPWPExclusive ? (
                  <React.Fragment>
                    <div className="text-sm">
                      <span className="font-montserrat font-medium">
                        {PWP.points}{" "}
                      </span>
                      <span className="font-montserrat uppercase">
                        {" "}
                        {languages.reviewPwpText
                          ? languages.reviewPwpText
                          : "ALL Reward points"}
                      </span>
                    </div>
                  </React.Fragment>
                ) : (
                  <div className="mt-1">
                    <span className="text-sm font-montserrat uppercase">
                      {item.selected_product[0].currency_text}{" "}
                    </span>
                    <span className="font-montserrat font-medium">
                      {totalAmount}
                    </span>{" "}
                    {PWP.exists &&
                      !item.selected_product[0].isQbr &&
                      isUserLogged && (
                        <React.Fragment>
                          {" "}
                          <span className="font-montserrat">
                            {languages.multiProductOr
                              ? languages.multiProductOr
                              : "OR"}
                          </span>{" "}
                          <span className="font-montserrat font-medium">
                            {PWP.points}
                          </span>{" "}
                          <span className="font-montserrat uppercase">
                            {languages.reviewPwpText
                              ? languages.reviewPwpText
                              : "ALL Reward points"}{" "}
                            {languages.reviewPerYear
                              ? languages.reviewPerYear
                              : "Per Year "}
                          </span>
                          <br />
                        </React.Fragment>
                      )}
                    {item.selected_product[0].isQbr && (
                      <div className="mb-3">
                        {/* <p className='font-montserrat'>Earn {item.selected_product[0].qbrPoints} Qantas Points with Qantas Business Rewards*</p> */}
                        {languages.qbrRewardPoints ? (
                          <p className="font-montserrat">
                            Earn {item.selected_product[0].qbrPoints} Qantas
                            Points with Qantas Business Rewards and{" "}
                            {languages.qbrRewardPoints} ALL reward points
                          </p>
                        ) : (
                          <p className="font-montserrat">
                            Earn {item.selected_product[0].qbrPoints} Qantas
                            Points with Qantas Business Rewards*
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
